
//import 'react-date-range/dist/styles.css'; // main style file
//import 'react-date-range/dist/theme/default.css'; // theme css file


import SJProbate from '../../views/SJProbate'
//import SJProbateComp from '../../views/SJProbateComp'

import SVRInvDest from '../../views/SVRInvDest'
import SVRInvAcDest from '../../views/SVRInvAcDest'
import CreateRoomFormFormBusCom from '../sojfind/CreateRoomFormFormBusCom';
import React, { Component } from "react";

//import Select from 'react-select'


//import { formatISO, format } from "date-fns";
import { AutoComplete , Input, Card, DatePicker, Select} from 'antd'

import { Icon,  Button as SVAButton} from 'antd';
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'


import moment from 'moment'
import momentLocaliser from 'react-widgets/lib/localizers/moment'
import { sojAndImagesSV } from '../../redux/svractions/svessearchActions';
//import { ar } from 'date-fns/locale';
//const format = require('date-fns/format'); 

import '../../css/SearchBar.css'
import 'antd/dist/antd.css'
import { changeConfirmLocale } from 'antd/lib/modal/locale';

import { Popover, Button } from 'antd';

const { Search } = Input;
const { MonthPicker, RangePicker } = DatePicker;
const { Option } = Select;

const text = <span>Room</span>;


const buttonWidth = 70;

const options = [
    { value: 'chocolate', label: 'Chocolatesweer' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
  ]

const hotels = [
    { value: 'jen', label: 'jen' },
    { value: 'ken', label: 'ken' },
    { value: 'ben', label: 'ben' }
  ]

  const locationOptions = [
    {
        "sojourncode": "201",
        "locationdata": " Hyatt, 153 scottland av, alabany city, ny 12120, us",
        "address_line1": " 253 scottland av",
        "address_line2": "albany "
    },
    {
        "sojourncode": "202",
        "locationdata": " CathyHotel, 153 scottland av, alabany city, ny 12130, us",
        "address_line1": " 410 scottland av",
        "address_line2": "albany "
    }]
  
class PbSearchBar extends Component{
   /*svmay3 start*/

   sojAndImagesSVUsingQuery(filter){
    const {startDate, endDate, hotels, esqueryText, esqueryAdults, esqueryChilds,esqueryInfants,} = filter
    const {values} = hotels
    //call action
    let start_date_s   = moment(startDate).toISOString() 
    console.log("**formatISO***", start_date_s)


    let moEndDate = moment(endDate)
    let moStartDate = moment(startDate)
    let mo_es = moEndDate.format('YYYY-MM-DD') 
    let mo_ss = moStartDate.format('YYYY-MM-DD') 
    let end_date_s   = moment(endDate).toISOString() 
    console.log("**formatISO***", end_date_s)
    let sojourn_location_s = ''
    let qLocation = 'Terrace'
    
    
    let sojPostRqOld = {
        "hotelIds": "HLPAR266",
        "adults": 1,
        "checkInDate": "2025-11-22",
        "roomQuantity": 1
    }
/* {
            "svfields": [
                "sojourn_name",
                "code",
                "address",
                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-08-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-08-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
            },
            "useCity": true,
            "dst": "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [
                13632,
                13621,
                12953
            ],
            "destinationCode": "MCO",
            "esqueryRooms": "r1"
        }
*/
let sojPostRq= {
    "svfields": [
        "images",
        "sojourn_name",
        "address",
       
        "code",
        "sojournGeocode",
        "categoryCode",
        "categoryGroupCode",
        "accommodationTypeCode",

        "sojourn_city",
        "countryCode",
        "stateCode",
        "postalCode",
         "countryCode",
         "ranking",
         "web",
         "terminals",
        "destinationCode"
    ],
    "dates": {
        "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2025-10-24" ),
        "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2025-10-27" ),
        "DT_FORMAT": "%Y-%m-%d",
        "time_zone": "Asia/Kolkata",
        "OP": "range"
    },
    "facets": {
        "accommodationTypeCode": "H"
    },
    "useCity": false,
    "dst": esqueryText ? esqueryText : "BEVERLY HILLS",
    "sv_room_data" : {
        "id": "-4",
        "fname": "Ror",
        "members":[
            {
               "rooms": 1,
             
              "adultType": "t2",
              "childType": "m0",
             
            }
          ]
       

    },

    "esqueryChilds": "m0",
    "esqueryInfants": "i0",
    "esqueryAdults": "t1",
    "esqueryCabin": "ECONOMY",
    "esqueryTripType": "roundtrip",
    "svpageSize": 5,
    "codeKeys": [
           
        ],
    "destinationCode": esqueryText ? esqueryText : "BEVERLY HILLS",
    "esqueryRooms": "r1"
}
sojPostRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
sojPostRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
sojPostRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")

 
/*

 let sojPostRqDyna = {
    "query": {
        "multi_match": {
            "fields": [
                "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
            ],
            "query": "WorldMark Long Beach",
            "operator": "or",
            "fuzziness": "AUTO"
        }
    },
    "post_filter": {
        "range" : {
            "STARTDATE": {
                "gte" : "2023-10-24",
                "lt" :  "2023-11-27",
                "time_zone": "+01:00"
            }
        }
      }
}
    let sojPostRqOldWorking = {
        "svfields": [
            "images",
            "sojourn_name",
           // "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
             "ranking",
             "web",
             "terminals",
            "destinationCode"
            
        ],
    
           "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-04-19",
                "ENDDATE_ITN_TZAWARE_EST": "2025-04-25",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "PMSRoomCode": "APT"
                },
            "useCity":true,
            "dst": esqueryText ? esqueryText : "PLAYA DE LAS AMERICAS",
            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esqueryCabin": "ECONOMY",
            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "destinationCode": "MCO",
            "esqueryRooms": "r1",
            "codeKeys": []
                
            
        }
    */
      console.log('sv*** calling action with postDatae')
      console.log(sojPostRq)
      console.log('sv*** calling action with postDatae done' )
     
     /*svmay3 start
    let sv_esquery_data = {}
     */
    
     let sv_esquery_data= {
        my_esqueryText: esqueryText,
        STARTDATE:(mo_ss ? mo_ss: "2023-10-24" ),
        ENDDATE:(mo_es ? mo_es: "2023-11-27" ),
        time_zone: "+01:00"

      }

      
     
       //this.props.sojAndImagesSojourn(sojPostRq, sv_esquery_data)
       this.props.sojAndImagesSojournPaginate(sojPostRq, sv_esquery_data)
       //this.props.sojAndImagesSV(esRealPostFIlterSearch, sv_esquery_data)
    /*svmay3 end */
      /*sv sept12 end */
      //make change in esingest java code with new controller to habdle this
    // this.props.sojAndImagesSV(esRealPostFIlterSearch)
     

}
   /*sv may3 end*/
    sojAndImagesSVUsingQuery_org(filter){
        const {startDate, endDate, hotels, esqueryText} = filter
        const {values} = hotels
        //call action
        let start_date_s   = moment(startDate).toISOString() 
        console.log("**formatISO***", start_date_s)


        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moment(endDate).toISOString() 
        console.log("**formatISO***", end_date_s)
        let sojourn_location_s = ''
        let qLocation = 'Terrace'
        if(values && values.value){
            sojourn_location_s = values.value
            if(sojourn_location_s == 'benServer'){
                qLocation = 'Brazil'

            }else if(sojourn_location_s == 'jenServer'){
                qLocation = 'usa'
            }else if(sojourn_location_s == 'kenServer'){
                qLocation = 'WA'
            }
        }
        
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": sojourn_location_s,
                  "operator": "and"
                },
                "from_date": {
                    "query": start_date_s,
                    "operator": "and"
                  },
                  "to_date": {
                    "query": end_date_s,
                    "operator": "and"
                  }

              }
            }
          }
          console.log('sv*** calling action with postDatae')
          console.log(sojPostRq)
          console.log('sv*** calling action with postDatae done' )
          /*localhost:8082/essearch/essojournlist*/
          //esqueryText
          let esRealPostFIlterSearchGoodSVButNodata = {
              "query": {
                  "multi_match": {
                      "fields": [
                          "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                      ],
                      "query": qLocation,
                      "operator": "or",
                      "fuzziness": "AUTO"
                  }
              },
              "post_filter": {
                  "range" : {
                      "STARTDATE": {
                          "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                          "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                          "time_zone": "+01:00"
                      }
                  }
                }
          }
          let esRealPostFIlterSearch_withDateRangeWorking = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : (mo_ss ? mo_ss: "2023-10-24" ),
                        "lt" : (mo_es ? mo_es: "2023-11-27" ), 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          let esRealPostFIlterSearch = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": qLocation,
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" :"2023-10-24" ,
                        "lt" : "2023-11-27" , 
                        "time_zone": "+01:00"
                    }
                }
              }
        }
          //woring
          //tmep
          esRealPostFIlterSearch["query"]["multi_match"]["query"] = esqueryText
          let sv_esquery_data = {
            my_esqueryText: esqueryText,
            STARTDATE:(mo_ss ? mo_ss: "2023-10-24" ),
            ENDDATE:(mo_es ? mo_es: "2023-11-27" ),
            time_zone: "+01:00"

          }
         /*svmay3 start*/
           this.props.sojAndImagesSojourn(esRealPostFIlterSearch, sv_esquery_data)
           //this.props.sojAndImagesSV(esRealPostFIlterSearch, sv_esquery_data)
        /*svmay3 end */
          /*sv sept12 end */
          //make change in esingest java code with new controller to habdle this
        // this.props.sojAndImagesSV(esRealPostFIlterSearch)
         

    }

    /*sv sept 12 end */
    loadDDValuesFromServer(){
        console.log('sv--calling acction getLocationDataDefaultFromServer')
        let rqOb = {"notnedded":1}

        let sdServer = "2024-06-22T23:42:55.795+00:00" 

        var str = '2011-04-11T10:20:30Z';
var date = moment(sdServer);
var dateComponent = date.utc().format('YYYY-MM-DD');
var timeComponent = date.utc().format('HH:mm:ss');
console.log(dateComponent);
console.log(timeComponent);

        let s =  moment().toISOString() 
        console.log("**formatISO***", s)
        //const result = formatISO(sdServer)


        this.props.getLocationDataDefaultFromServer(rqOb)


    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        this.loadDDValuesFromServer()
        //console.log(this.props.params)
    }
    componentDidMount(){
       // const f = this.availProcess(this.props.hotelDest,this.props.startDate, this.props.endDate)
       const {hotels,hotelsSelected, ddData, startDate, endDate , dataSourceSV}= this.props.locationData
       let f = {
            all: [], // Contains the full data
            hotels: {
                options:[
                    { value: 'jen', label: 'jen2Server' },
                    { value: 'ken', label: 'ken2Server' },
                    { value: 'ben', label: 'ben2Server' }
                ],
                values: { value: 'ken', label: 'ken2Server' }
            }
        };
        f['hotels']['options'] = hotels
        f['hotels']['values'] = hotelsSelected
        let items = []
        /*
        if(hotels){
           
           
               Array.forEach(hotels, (ob, i)=>{
                   items.push(ob['label'])

               })

        }
        f['hotels']['dataSourceSV'] = items
        */
        let  momIsoStartDate = moment(startDate);
        let  momIsoEndDate = moment(endDate);
////var dateComponent = date.utc().format('YYYY-MM-DD');
//var timeComponent = date.utc().format('HH:mm:ss');
        f['startDate'] = momIsoStartDate
        f['endDate'] = momIsoEndDate
        f['dataSourceSV'] = dataSourceSV
        this.setState({filters:f} )
       // this.setState({filters:f})

    }
    cbFilterac = (inputValue, option)  => {
        /** plain vanilla to return the options that has above inputValue as substring
         */
        console.log('sv$$$$$$$$$***onChangeac***')
       console.log(inputValue)
       console.log(option)
       console.log('sv$$$$$$$$$***onChangeac ebd***')
       let bValid = option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
       return bValid
                              
      //this.setState({ selectedOption: option, inputValue: data });
    };
    onSearchac = searchText => {
        this.setState({
          dataSource: !searchText ? [] : [searchText, searchText.repeat(2), searchText.repeat(3)],
        });
      };

      onSearchtxt = qText => {

        let f = this.state.filters
       
        //let  momIsoStartDate = moment(startDate);
        //let  momIsoEndDate = moment(endDate);
////var dateComponent = date.utc().format('YYYY-MM-DD');
//var timeComponent = date.utc().format('HH:mm:ss');
//nonISO
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
       
      };
      /*
      onChangedsSV = (data, option)  => {
       
        console.log('sv$$$$$$$$$***onChangeac***')
       console.log(data)
       console.log(option)
       
       const rqBody = {inputValueds: data}
       this.props.esautocompleteNow(rqBody)
       console.log('sv$$$$$$$$$***onChangeac ebd***')
     // this.setState({ selectedOptionds: option, inputValueds: data });
    };
*/
    onSelectdsSV = (ddLabel, option) => {
      console.log('sv$$$$$$$$$***onSelectac***')
      console.log(ddLabel)
      console.log(option)
      console.log('sv$$$$$$$$$***onSelectac ebd***')
      this.setState({ selectedOptionds: option, inputValueds: option.label });
    };
      onChangeac = (data, option)  => {
          /** data is the user vals or label that we sotr as inputValue
           * option has storew with key val
           */
          console.log('sv$$$$$$$$$***onChangeac***')
         console.log(data)
         console.log(option)
         console.log('sv$$$$$$$$$***onChangeac ebd***')
        this.setState({ selectedOption: option, inputValue: data });
      };

      onSelectac = (data, option) => {
        console.log('sv$$$$$$$$$***onSelectac***')
        console.log(data)
        console.log(option)
        console.log('sv$$$$$$$$$***onSelectac ebd***')
        this.setState({ selectedOption: option, inputValue: option.label });
      };

    constructor(props) {
        super(props)
        this.onSearchDesttxtFancy = this.onSearchDesttxtFancy.bind(this)
        this.onSearchDesttxtFancyAc = this.onSearchDesttxtFancyAc.bind(this)
        
        this.getSojHtmlPicker = this.getSojHtmlPicker.bind(this)
        this.handleTravellerChange = this.handleTravellerChange.bind(this)
        this.handleChildChange = this.handleChildChange.bind(this)
       
        this.getSojOverlay = this.getSojOverlay.bind(this)
        this.nroomsSummary = this.nroomsSummary.bind(this)
        this.sjroomsubmitparent = this.sjroomsubmitparent.bind(this)
        //let me = this
       
        this.onTripChange_sojourn = this.onTripChange_sojourn.bind(this)
       
        this.cbFilterac = this.cbFilterac.bind(this)
       this.onSelectdsSV = this.onSelectdsSV.bind(this)
      // this.onChangedsSV = this.onChangedsSV.bind(this)
        this.onSelectac = this.onSelectac.bind(this)
        this.onChangeac = this.onChangeac.bind(this)
        this.onSearchac = this.onSearchac.bind(this)
        this.onSearchtxt = this.onSearchtxt.bind(this)
        this.sojAndImagesSVUsingQuery = this.sojAndImagesSVUsingQuery.bind(this)
       // this.flyAndImagesSVUsingQuery = this.flyAndImagesSVUsingQuery.bind(this)
        this.loadDDValuesFromServer = this.loadDDValuesFromServer.bind(this)
        this.updateHotelsDD = this.updateHotelsDD.bind(this)
        this.ddChange = this.ddChange.bind(this)
        this.buttonShouldBeDisabled = this.buttonShouldBeDisabled.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
        this.handleInit = this.handleInit.bind(this)
        this.state = { 
            value: '', 
            inputValueds:'',
            //inputValue:'react',
            selectedOptionds: '',
            inputValue:'react',
           
            //inputValue:'react',
            selectedOption: { label: "react", value: "3" },
            dataSource:[
                { label: "hello", value: "1" },
                { label: "codesandbox", value: "2" },
                { label: "react", value: "3" },
                { label: "nodejs", value: "4" },
                { label: "java", value: "5" },
                { label: "antd", value: "6" },
                { label: "dependency", value: "7" },
                { label: "less", value: "8" }
              ],
            /*
            svstate : {
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            },  
            */
            ids: ['APP_OPERATIONAL_STATUS', 'DV_U_SERVICE_ASG', 'DV_U_SERVICE_NAME', 'DV_U_SERVICE_OFFERING', 'APPLICATION_NAME'],
            labels: ['Status', 'Service ASG', 'Service Name', 'Service Offering', 'Application'],
            filters: {
                
                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
               // "endDate": "2024-07-22T25:42:55.795+00:00" ,
               startDate : new Date(),
               endDate : new Date(),
               esqueryAdults:"t1",
               esqueryChilds:"m1",
               esqueryInfants:"i0",

               esqueryText: '',
               
               dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
            
              
                key: 'selection',
                "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
                hotels: {
                    
                    options:[
                        { value: 'jen', label: 'jen1Server' },
                        { value: 'ken', label: 'ken1Server' },
                        { value: 'ben', label: 'ben1Server' }
                    ],
                    values: { value: 'ken', label: 'ken1Server' }
            },
                HOTEL_DEST: {
                    id: "HOTEL_DEST_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Hptel Location",
                    values: [],
                    showing: []

                },
                HOTEL_DATE_RANGE: {
                   
                        startDate: new Date(),
                        endDate: new Date(),
                   
                    key: 'selection'
                    
                },
                APP_OPERATIONAL_STATUS:{
                    id: "APP_OPERATIONAL_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Status",
                    values: [],
                    showing: []
                },
                
                APPLICATION_NAME: {
                    id: "APPLICATION_NAME",
                    defaultOptions: [],
                    options: [],
                    label: "Applications",
                    values: [],
                    showing: []
                }
              
            }
        }
    }
    handleInit(ranges){
        console.log('handleInit');
        console.log(ranges);

    }
    handleSelect(ranges){
        console.log(ranges);
        const { startDate, endDate }= ranges
        let f = this.state.filters
       
         //let  momIsoStartDate = moment(startDate);
         //let  momIsoEndDate = moment(endDate);
 ////var dateComponent = date.utc().format('YYYY-MM-DD');
 //var timeComponent = date.utc().format('HH:mm:ss');
 //nonISO
         f['startDate'] = startDate
         f['endDate'] = endDate
         this.setState({filters:f} )


        
        // {
        //   selection: {
        //     startDate: [native Date Object],
        //     endDate: [native Date Object],
        //   }
        // }
      }

    buttonShouldBeDisabled(){
        if( this.state.filters.APPLICATION_NAME.values.length > 0)
            return false;
       
        return true
    }
    updateHotelsDD(statekey,obSelect){
        console.log('sv**** user selected hotel start')
        console.log(obSelect)
        console.log('sv**** user selected hotel ..')
        let f = this.state.filters

       
        f['hotels']['values'] = obSelect
        this.setState({filters:f} )

    }
    ddChange(rangesGot){
        
        console.log(rangesGot)
    }
    /*svmay11 start*/
    onSearchDesttxtFancyAc = qText => {
        console.log('SV*May11 onSearchDesttxtFancyAc for select')
        console.log(qText)

    
        let f = this.state.filters
       
     
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
       // this.saveFindState()
        
      };
 /*svapr29 start */
    onSearchDesttxtFancy = qText => {
        console.log('SV*8apr29 for select')
        console.log(qText)

    
        let f = this.state.filters
       
     
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
       // this.saveFindState()
        
      };
    
    handleTravellerChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryAdults'] = !qText ? 't1' :  qText
        this.setState({filters:f} )
        //this.saveFindState()

    }
    handleChildChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryChilds'] = !qText ? 'm1' :  qText
        this.setState({filters:f} )
       // this.saveFindState()


    }
    
      sjroomsubmitparent(values){
        let me = this
        
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      
      console.log(values)
      let id = -13;
      
      ///essearch/spaceBookNow
      //get props.state 
      //console.log(this.props.my_data_traveller)
      let spaces = []
      let esqueryChilds = "m0", esqueryAdults ="t2"
      if(values ){
          let full_name = ""
         const {members} = values
         let occupancies =  [
            {
              "rooms": 1,
              "adults": 2,
              "children": 0
            }
          ]
         
         
         members.forEach( (o,i)=>{
             let space = {
                "rooms": 1,
                "adults":"t2",
                "children": "m0"
              }
              space.rooms = (i + 1)
              space.adultType = o.adultType
              space.childType = o.childType
              spaces.push(space)
              if(i === 0){
                esqueryChilds = o.childType
                esqueryAdults = o.adultType
              }

         })

             }
         let comroomAndTraveller = {
                roomNew : values
       
            }  
      console.log('comroomAndTraveller****',comroomAndTraveller)

      let  sv_room_data = {
        "id": "-4",
        "fname": "Ror",
        "members":[
            {
              
              "adultType": "t2",
              "childType": "m0"
             
            }
          ]
       

      }
      sv_room_data.members = spaces
      let f = this.state.filters
       
      if(sv_room_data){
            f['sv_room_data'] = sv_room_data
            f["esqueryChilds"] = esqueryChilds
            f["esqueryAdults"] = esqueryAdults
            this.setState({filters:f} )
      }
     
      
     

      this.props.saveRoomSuccess(sv_room_data)
     
  
    } 
    nroomsSummary(){
        let sv_room_data = {
            "id": "-4",
            "fname": "Ror",
            "members":[
                {
                   "rooms": 1,
                  "documentType": "IDENTITY_CARD",
                  "adultType": "t2",
                  "childType": "m0",
                  "holder": "Y"
                }
              ]
           
    
          }
          let f = this.state.filters
          if(f.sv_room_data){
              sv_room_data = f.sv_room_data
          }
          let {members} = sv_room_data
          let nroom = 0, nadults = 0 , nchild =0, ntr =0, s=""
          members.forEach( (r,i)=>{
              nroom += 1
             
              if(r.adultType && (r.adultType.length > 1) ){
                s = r.adultType
                nadults = parseInt(s.substr(1,s.length))
              }
              if(r.childType && (r.childType.length > 1) ){
                s = r.childType
                nchild = parseInt(s.substr(1,s.length))
              }
              ntr +=(nadults + nchild) 
             
             


          })
          let tcontent = `${nroom} Room, ${ntr} Travellers`
          console.log(tcontent)
          return tcontent
    }
    getSojOverlay(){
        const {sjroomsubmitparent} = this
        let det = {
            "id": 1,
            "customerId": -4,
            "fname": "John",
            "cardId": "-4",
            "adultType": "t5",
            "childType": "m2",
            "card": "7777-1234--1234--1234" 

            
        }
       

        return ( <div className="row">

                                                <div className="o-container-fpplist">
                                                      
                                                      
                                                      <div className="o-box-fpplist-b1">
                                                       
                                                            <div style={{paddingTop:'10px'}}>
                                                                <CreateRoomFormFormBusCom  det={det}  svsubmitparent={sjroomsubmitparent} onSubmit={sjroomsubmitparent}></CreateRoomFormFormBusCom>
                                                                
                                                            </div>   
                                                  
                                                      </div>
                                                </div>

        </div>)

    }
    getSojOverlayOrg(){
        const content = (
            <div className="row">
                    <div className="c-container-profilebar">
                        <div className="c-box-profilebar">
                                    <span className="c-span">
                                    <Select defaultValue="t1" style={{ width: 120 }} onChange={this.handleTravellerChange}>
                                    <Option value="t1">1 Adult</Option>
                                    <Option value="t2">2 Adult</Option>
                                    <Option value="t3">3 Adult</Option>
                                    <Option value="t4">4 Adult</Option>
                                    <Option value="t5">5 Adult</Option>
                                    <Option value="t6">6 Adult</Option>
                                    
                                    </Select>
                                    </span>
                        </div>
                        <div className="c-box-profilebar">
                                    <span className="c-span">
                                    <Select defaultValue="m0" style={{ width: 120 }} onChange={this.handleChildChange}>
                                    <Option value="m0">No Child</Option>
                                    <Option value="m1">1 Child</Option>
                                    <Option value="m2">2 Child</Option>
                                    
                                    </Select>
                                    </span>
                        </div>
                </div>
          </div>
        );
        return content

      }
    getSojHtmlPicker(){
        let qt = 'roundtrip'
        if(qt == 'onewaytrip'){
           

            return (
                
                <div>
                                <br />
                                {/* <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}> */}
                                <Card title="Dates" bordered={false} style={{ width: 300 }}>

                                    <DatePicker onChange={this.onTripChange_Oneway_cosmos} />
                                </Card>
                </div>

            )
            
        }else if(qt == 'roundtrip'){ 
            return (
                
                <div>
                                <br />
                                {/* <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}> */}
                                <Card title="Dates Filing" bordered={false} style={{ width: 300 }}>
                                    <RangePicker onChange={this.onTripChange_sojourn} />
                                </Card>
                </div>

            )
            
        
        }
        
    }


    onTripChange_sojourn(dateMoment, sdate, tpdateMoment, tosdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd[0]
        let tmo = fmd[1]
        let moEndDate = moment(tmo)
        let moStartDate = moment(fmo)
        console.log(fmd)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moEndDate.toISOString() 
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
        console.log("To**formatISO***", end_date_s)
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
        f['endDate'] = !tmo ? today_dt :  tmo
        this.setState({filters:f} )
       // this.saveFindState()

    }
     /*svapr29 end */
    render(){
        const me = this
        console.log('sv*** this.props')

        console.log(this.props)
        const options =[
            { label: "hello", value: "1" },
            { label: "codesandbox", value: "2" },
            { label: "react", value: "3" },
            { label: "nodejs", value: "4" },
            { label: "java", value: "5" },
            { label: "antd", value: "6" },
            { label: "dependency", value: "7" },
            { label: "less", value: "8" }
          ]
        const { dataSource, inputValue } = this.state
        
        const {locationData} = this.props
        //const dataSourceSV = this.state.filters['dataSourceSV']

       

        const {ddData, dataSourceSV} = locationData
        
        const svselectionRange = {
            startDate: new Date(),
            endDate: new Date(),
            key:'selection'
        }
        const bdisableDaysBeforeToday = true
       // const dataSourceSV = ['Burns Bay Road', 'Downing Street', 'Wall Street'];
       

        return (
            <div>
                <div className="searchBar">
               
    

                    <div className="container-fluid">
                      
                        <div className="row">
                        <div className="c-container-sbar">
                        {/*  
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="Hotel"  bordered={false} style={{ width: 300 }}>
                                   
                                     <SVRInvDest onSearchDesttxtFancy={this.onSearchDesttxtFancy}/>
                                   
                                     
                                   
                                    </Card>

                              
                            </div>
                            
                            </span>
                        </div>
                     */}
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="Where(Primary Residence)"  bordered={false} style={{ width: 300 }}>
                                   {/* 
                                    <Card title="Destination(Hotel/City/Destination)"  bordered={false} style={{ width: 300 }}>
                                
                                    <SVRAiport onSearchOrgtxtFancy={this.onSearchtxt}/>
                                  
                                     <Search
                                        placeholder="From"
                                        onSearch={this.onSearchOrgtxt}
                                        style={{ width: 200 }}
                                        />
                                   
                                    
                                     */}
                                     <SVRInvAcDest onSearchDesttxtFancyAc={this.onSearchDesttxtFancyAc}/>
                                   
                                     
                                   
                                    </Card>

                              
                            </div>
                            
                            </span>
                        </div>
                        {/*  
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="Test ?"  bordered={false} style={{ width: 300 }}>
                                  
                                     
                                     <SJProbate />
                                     
                                   
                                    </Card>

                              
                            </div>
                            
                            </span>
                        </div>
                        */}
                        <div className="c-box-flybar">
                            <span className="c-span">
                            {this.getSojHtmlPicker()}
                            
                            </span>
                        </div>
                         {/*
                        <div className="c-box-flybar">
                        <span className="c-span" >
                            <div>
                                <br/>
                                <Card title="Travellers"  bordered={false} style={{ width: 200 }}>
                                
        <Popover placement="bottomRight" title={text} content={this.getSojOverlay()} trigger="click">
            <Button>{this.nroomsSummary()}</Button>
        </Popover>

                                </Card>
                            </div>
                            
                           
                        </span>
                        </div>
                           

                             <span className="c-span">
                                <DateRange disableDaysBeforeToday={bdisableDaysBeforeToday} onInit={this.handleInit}  onChange={this.handleSelect} />
                           </span>
                             */}
                           
                           
                          
                           <div className="c-box-sbar" style={{width:"100px"}}>
                                <span className="c-span">
                                    <br />

                                     <Card title=""  bordered={false} style={{ width: 390 }}>
                                     <button type="submit" className="btn btn-success" onClick={()=>this.sojAndImagesSVUsingQuery(this.state.filters)}>
                                        Search Probate Court
                                    </button>  
                                     </Card>
                            
                                   

                                   
                            
                                </span>
                            </div>
                     </div>
                                    
                            
                            
                        </div>
                    </div>
                </div>
            </div>
           
        )
    }




}

export default PbSearchBar